module.exports = __webpack_public_path__ + "static/media/sunarch_31.bebec649.gif";